export default __webpack_public_path__ + "static/media/featured-in-5.3ba92187.png";